import { render, staticRenderFns } from "./VueDjGantt.vue?vue&type=template&id=7f0694b8"
import script from "./VueDjGantt.vue?vue&type=script&lang=js"
export * from "./VueDjGantt.vue?vue&type=script&lang=js"
import style0 from "./VueDjGantt.vue?vue&type=style&index=0&id=7f0694b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports